import styled from "styled-components";
import {TextDefaultButton} from "@FRAMEWORK/ui/desktop/button";
import {Ellipsis} from "@FRAMEWORK/ui/desktop/text";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";

const Box = styled.div<{isFixed?: boolean}>`
	position: sticky;
	top: 0;
	float: right;
	width: 260px;
	margin-top: -7px;
	border: 1px solid var(--placeholder-color);
	border-radius: 8px;
	box-sizing: border-box;
	overflow: hidden;

	${props =>
		props.isFixed === false &&
		`
		position: static;
	`}
`;

const DepartureWrap = styled.div`
	padding: 24px 0;
	margin: 0 20px;
	box-sizing: border-box;
`;

const InfoList = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 15px;
	line-height: 1;

	li {
		display: flex;
		justify-content: space-between;
		gap: 20px;

		span {
			color: var(--sub-title-color);
			flex-shrink: 0;
			font-size: var(--basic-size);
			font-family: "PT-medium";
		}

		em {
			color: var(--title-color);
			font-family: "PT-semibold";
			font-size: var(--basic-size);
			${Ellipsis(1)};
		}
	}
`;

const PriceWrap = styled.ul`
	display: flex;
	padding: 24px 0;
	margin: 0 20px;
	border-top: 1px solid var(--line-color);
	flex-direction: column;
	gap: 20px;

	li {
		display: flex;
		line-height: 1;
		align-items: center;
		justify-content: space-between;
	}
`;

const Amount = styled.span`
	display: inline-flex;
	align-items: center;
	span {
		display: inline-flex;
		align-items: center;
		min-width: 25px;
		font-family: "PT-medium";
		font-size: var(--basic-size);
		color: var(--sub-title-color);

		+ span {
			&::before {
				display: block;
				width: 18px;
				line-height: 1;
				height: 18px;
				margin: 0 2px 0 3px;
				background: url(${SpriteImage}) no-repeat -34px -372px;
				content: "";
			}
		}
	}
`;

const Age = styled.span`
	display: flex;
	width: 76px;
	font-family: "PT-medium";
	font-size: var(--small-size);
	color: var(--sub-title-color);
	em {
		margin: 0 1px 0 9px;
	}

	span {
		width: 30px;
		text-align: right;
	}
`;

const PriceText = styled.span`
	font-family: "PT-bold";
	font-size: var(--default-size);
	color: var(--title-color);

	span {
		font-family: "PT-semibold";
		margin-left: 3px;
	}
`;

const Coupon = styled.span``;

const Discount = styled.span``;

const CouponWrap = styled.div`
	display: flex;
	padding: 20px 0 24px;
	margin: 0 20px;
	border-top: 1px solid var(--line-color);
	flex-direction: column;
	gap: 8px;

	button {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 6px;
		height: 24px;
		padding: 2px 8px;
		border-radius: 8px;
		border: 1px solid var(--brand-deep-color);
		background: #fff9e8;
		font-size: var(--small-size);
		font-family: "PT-bold";
		color: var(--brand-deep-color);

		&::before {
			display: flex;
			width: 16px;
			height: 16px;
			background: url(${SpriteImage}) no-repeat 0 -372px;
			content: "";
		}
	}

	span {
		line-height: 1.5;
		font-size: var(--basic-size);
		font-family: "PT-medium";
		color: var(--sub-title-color);
	}

	> div:not(:first-of-type) {
		padding-left: 16px;
		box-sizing: border-box;
		border-left: 2px solid var(--hr-color);
	}

	${Discount} {
		color: var(--alert-color);
		> span {
			color: var(--alert-color);
		}
	}
`;

const TotalWrap = styled.div`
	padding: 0 20px 24px;
	text-align: right;
`;

const TotalPrice = styled.div<{$disabled?: boolean}>`
	display: flex;
	flex-direction: column;
	line-height: 1.5;
	margin-bottom: 8px;
	font-family: "PT-medium";
	font-size: var(--regular-size);
	text-align: right;
	color: ${({$disabled}) => ($disabled ? `var(--disable-text-color)` : `var(--title-color)`)};
	strong {
		font-family: "PT-bold";
		font-size: 26px;
	}
`;

const ReservationPrice = styled.p`
	font-family: "PT-medium";
	font-size: var(--basic-size);
	color: var(--primary-color);
	> em {
		font-family: "PT-bold";
	}
`;

const PriceInfo = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	margin-bottom: 16px;

	button {
		display: flex;
		align-items: center;
		line-height: 1.5;
		background-color: #fff;
		color: var(--sub-title-color);
		font-family: "PT-medium";
		font-size: var(--basic-size);
		&::after {
			display: block;
			width: 18px;
			height: 18px;
			margin-left: 4px;
			background: url(${SpriteImage}) no-repeat -16px -372px;
			content: "";
		}
	}
	p {
		line-height: 1.5;
		color: var(--sub-title-color);
		font-family: "PT-medium";
		font-size: var(--basic-size);
	}
`;

const Tooltip = styled.div`
	position: absolute;
	top: -20px;
	left: 50%;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	width: fit-content;
	height: 26px;
	padding: 4px 16px;
	border-radius: 6px;
	border: 1px solid var(--border-color);
	background-color: #fff;
	transform: translateX(-50%);
	filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.2));
	box-sizing: border-box;

	> p {
		line-height: 1.5;
		color: var(--title-color);
		font-family: "PT-semibold";
		font-size: var(--small-size);
		white-space: nowrap;
	}

	&::after {
		content: "";
		position: absolute;
		bottom: -6px;
		left: 50%;
		width: 11px;
		height: 11px;
		background-color: #fff;
		border: 1px solid var(--border-color);
		border-top: 0;
		border-left: 0;
		transform: translateX(-50%) rotate(45deg);
		border-bottom-right-radius: 2px;
		z-index: -1;
	}
`;

const Reservation = styled.div`
	position: relative;

	&:has(${Tooltip}) {
		margin-top: 42px;
	}
`;

const ManagerBox = styled.div`
	padding: 16px 20px;
	background-color: var(--label-bg-color);
	dl {
		display: flex;
		flex-wrap: wrap;
		gap: 4px 8px;
		font-size: var(--basic-size);
	}

	dt {
		line-height: 1.5;
		font-family: "PT-medium";
		color: var(--sub-title-color);
	}
	dd {
		position: relative;
		line-height: 1.5;
		color: var(--title-color);
		font-family: "PT-semibold";
	}
`;

const ScrollWrap = styled.div<{isOption?: boolean}>`
	overflow-y: auto;
`;

const Assort = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
`;

const DepartureButton = styled(TextDefaultButton)`
	margin-top: 16px;
	width: 100%;
	font-size: var(--default-size);
	background-color: var(--title-color);
	color: #fff;
`;

const ReservationScrollWrap = styled.div<{isOption?: boolean}>`
	/* height: calc(100vh - 301px); */
	// 옵션이 없을 경우
	/* max-height: ${props => (props.isOption ? `324px;` : `295px;`)}; */
	overflow-y: auto;
`;

const Banner = styled.a`
	display: block;
	margin-top: 24px;
	width: 100%;

	img {
		width: 218px;
	}
`;

const ReservationButton = styled(TextDefaultButton)<{waiting?: boolean; isDisabled?: boolean}>`
	width: 100%;
	height: 56px;
	font-family: "PT-bold";
	font-size: var(--medium-size);
	background-color: var(--brand-color);
	padding: 4px 16px;
	/* color: ${({waiting}) => (waiting ? "#fff" : "var(--title-color)")}; */
	color: var(--title-color);

	${({isDisabled}) =>
		isDisabled
			? `
		background-color: var(--disable-text-color);
		color: #fff;
		cursor: unset;`
			: ``}
`;

export {
	DepartureWrap,
	Box,
	InfoList,
	PriceWrap,
	Age,
	PriceText,
	CouponWrap,
	Coupon,
	TotalWrap,
	TotalPrice,
	PriceInfo,
	Reservation,
	ManagerBox,
	ScrollWrap,
	Assort,
	Discount,
	DepartureButton,
	ReservationScrollWrap,
	Banner,
	Amount,
	ReservationPrice,
	Tooltip,
	ReservationButton,
};
